export default __webpack_public_path__ + "static/media/BHC-BNB.4fc24c50.png";